export const state = () => ({
  videoLink: "",
  videoSize: "",
  videoTitle: "",
  isOpen: false,
});

export const mutations = {
  setOpen(state, params) {
    state.isOpen = true;
    state.videoLink = params.link;
    state.videoSize = params.size;
    state.videoTitle = params.title;
  },

  closePopUp: function (state) {
    state.isOpen = false;
    state.videoLink = "";
    state.videoSize = "";
    state.videoTitle = "";
  }
};
